import * as actionTypes from '../action-types';
import { WatchersActions } from '../actions';

type Reducer = { [key: string]: string };

const defaultState: Reducer = {};

export function watchersDecisionsMapReducer(
  state: Reducer = defaultState,
  action: WatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHER: {
      const { watcher } = action.payload;
      return { ...state, [watcher.key]: watcher.numberOfNewDecisions };
    }
    case actionTypes.SET_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.reduce((acc: { [key: string]: string }, watcher) => {
        acc[watcher.key] = watcher.numberOfNewDecisions;
        return acc;
      }, {});
    }
    case actionTypes.CREATE_WATCHER: {
      const { watcher } = action.payload;
      return { ...state, [watcher.key]: watcher.numberOfNewDecisions };
    }
    case actionTypes.DELETE_WATCHER: {
      const { watcherKey } = action.payload;
      const { [watcherKey]: removed, ...rest } = state;
      return rest;
    }
    case actionTypes.SET_DECISION_AS_READ: {
      const { watcherKey } = action.payload;
      const initialNumberOfNewDecisions = parseInt(state[watcherKey], 10);
      return {
        ...state,
        [watcherKey]: String(initialNumberOfNewDecisions - 1),
      };
    }

    case actionTypes.SET_ALL_DECISIONS_AS_READ: {
      const { watcherKey } = action.payload;
      return { ...state, [watcherKey]: '0' };
    }
    default: {
      return state;
    }
  }
}
